import { configureStore } from "@reduxjs/toolkit";
import postsReducer from "./reducers/setPosts";
import dictationReducer from "./reducers/dictation";
import practiceReducer from "./reducers/practice";
import aiChatReducer from "./reducers/aiChat";
import appointmentReducer from "./reducers/appointment";

const store = configureStore({
  reducer: {
    posts: postsReducer,
    dictation: dictationReducer,
    practice: practiceReducer,
    appointment: appointmentReducer,
    aiChat: aiChatReducer,
  },
});

export default store;
